import { Component, Input, OnInit } from '@angular/core';
import { AyaProgramDatesComponent } from '../aya-program-dates/aya-program-dates.component';
import { AyaSessionBreaksComponent } from '../aya-session-breaks/aya-session-breaks.component';
import { AyaSupplementsComponent } from '../aya-supplements/aya-supplements.component';
import { AcademicYearSupplements, AyaPriceListProgramDate, AyaSchoolsByCountryTable, AyaSchoolTableView, SessionBreaks } from '../../models';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-extra-info',
  templateUrl: './aya-extra-info.component.html',
  styleUrls: ['./aya-extra-info.component.scss', './print-aya-extra-info.component.scss'],
  imports: [AyaProgramDatesComponent, AyaSessionBreaksComponent, AyaSupplementsComponent],
})
export class AyaExtraInfoComponent implements OnInit {
  @Input() schoolTables: AyaSchoolsByCountryTable[] | undefined;

  protected programDates: AyaPriceListProgramDate[] | undefined;
  protected sessionBreaks: SessionBreaks | undefined;
  protected supplements: AcademicYearSupplements | undefined;

  ngOnInit(): void {
    const schools = (this.schoolTables ?? []).flatMap((country) => country.schools ?? []);
    this.programDates = this.extractProgramDates(schools);
    this.sessionBreaks = this.extractSessionBreaks(schools);
    this.supplements = this.extractSupplements(schools);
  }

  private extractProgramDates(schools: AyaSchoolTableView[]): AyaPriceListProgramDate[] {
    return Array.from(new Map(schools.flatMap((school) => school.programDates ?? []).map((pd) => [pd.startDate, pd] as const)).values());
  }

  private extractSessionBreaks(schools: AyaSchoolTableView[]): SessionBreaks {
    return {
      breaks: Array.from(new Map(schools.flatMap((school) => school.sessionBreaks?.breaks ?? []).map((b) => [b.courseStartDate, b] as const)).values()),
    } as SessionBreaks;
  }

  private extractSupplements(schools: AyaSchoolTableView[]): AcademicYearSupplements | undefined {
    return schools.find((s) => !!s.supplements)?.supplements as AcademicYearSupplements;
  }
}
